import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const inquirySubmit = createAsyncThunk(
    'inquiry/inquirySubmit',
    async ({ id, first_name, last_name, email, phone_number, message, country }, { rejectWithValue }) => {
        try {
            const body = JSON.stringify({
                name: `${first_name} ${last_name}`,
                phone_number: phone_number,
                email: email,
                message: message,
                vehicleId: +id,
                country: country
            });

            const response = await axios.post(`${PUBLIC_BASE_URL}/client-requests/create-client-request`, body, axiosConfig);
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);
